module.exports = __webpack_public_path__ + "img/7.12e0c738.svg";